import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="capabilities-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-granite py-4"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-8 pr-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="whitespace-nowrap font-display text-lg font-semibold uppercase tracking-[0.15em] text-slate-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand-light" />
          </span>
        ))}
      </div>
    </div>
  );
};
